import React from 'react';
import { CountryCodeEnum } from '../../../common/types';

import MevueloUYPaymentMethods from './MevueloUy';
import MevueloPYPaymentMethods from './MevueloPy';
import MevueloBOPaymentMethods from './MevueloBo';
import MevueloCOPaymentMethods from './MevueloCo';
import ItauPYPaymentMethods from './ItauPy';

interface Props {
	country: string;
	isExternal?: boolean;
}

export default function PaymentMethods(props: Props): JSX.Element {
	switch (props.country) {
		case CountryCodeEnum.URUGUAY:
			return <MevueloUYPaymentMethods isExternal={props.isExternal} />;
		case CountryCodeEnum.PARAGUAY:
			return <MevueloPYPaymentMethods isExternal={props.isExternal} />;
		case CountryCodeEnum.BOLIVIA:
			return <MevueloBOPaymentMethods isExternal={props.isExternal} />;
		case CountryCodeEnum.COLOMBIA:
			return <MevueloCOPaymentMethods isExternal={props.isExternal} />;
		case CountryCodeEnum.TN_ITAU_PY:
			return <ItauPYPaymentMethods isExternal={props.isExternal} />;
		default:
			return <MevueloUYPaymentMethods isExternal={props.isExternal} />;
	}
}
